import { gql } from '@apollo/client'

const DELETE_PRIORITY_TASK_MUTATION = gql`
  mutation deletePriorityTaskMutation($id: ID!) {
    deletePriorityTask(id: $id)
  }
`

export default DELETE_PRIORITY_TASK_MUTATION
